import React from 'react'
import RecordForm from '../../../../../../generic/universal-table/components/RecordForm/RecordForm'
import { GrowerUiRow } from '../types/growerTable.types'

type GrowerFormProps = React.ComponentProps<typeof RecordForm<GrowerUiRow>>

// Thin module-named wrapper so AppModal has a stable `Children` seam (and a place for
// any future grower-specific glue). All logic lives in the unified RecordForm.
const GrowerForm = (props: GrowerFormProps) => <RecordForm<GrowerUiRow> {...props} />

export default GrowerForm
